module.exports = __webpack_public_path__ + "assets/img/3-m.2242a543.jpg";